/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { contentOptions } from '../../handlers'
import BuildLicenseTerms from '@/components/forms/predefined/BuildLicenseListingTerms'
import PreBlock from '@/components/others/PreBlock'
import AiMetadata from '../AiMetadata'
import AddAiMetadata from './components/AddAiMetadata'
import LicensingHistory from '../LicensingHistory'
import RevenueBreakdown from './components/RevenueBreakdown'

const ContentOptions = ({
  handleCloseListSam,
  itemsResponse,
  licenseHistory,
  onCloseOptions,
  optionSelected,
  reloadSam,
  samId,
  submitBuildLicenseTerms,
  unlistBuildLicenseTerms
}) => {
  if (!itemsResponse) return null

  const renderContent = () => {
    switch (optionSelected) {
      case contentOptions.listSams:
        return (
          <BuildLicenseTerms
            onSubmit={submitBuildLicenseTerms}
            onUnlist={unlistBuildLicenseTerms}
            assetData={itemsResponse}
            onClose={handleCloseListSam}
            className="w-full mb-5"
            defaultValues={itemsResponse.aiUsageLicensingPreferences}
          />
        )

      case contentOptions.metadata:
        return (
          <PreBlock className="mb-4">
            {JSON.stringify(itemsResponse.metadata, null, 2)}
          </PreBlock>
        )

      case contentOptions.aiMetadata:
        return (
          <AiMetadata
            samId={samId}
          />
        )

      case contentOptions.addAiMetadata:
        return (
          <AddAiMetadata
            isOpen
            sam={itemsResponse}
            onClose={onCloseOptions}
            reloadSam={reloadSam}
          />
        )

      case contentOptions.revenueBreakdown:
        return (
          <RevenueBreakdown />
        )

      default:
        return null
    }
  }

  return (
    <div className="min-w-0">
      { renderContent() }

      <div className="w-full">
        <LicensingHistory
          licenseHistory={licenseHistory}
        />
      </div>
    </div>
  )
}

export default ContentOptions
